import { Mapper } from '@empathy/search-adapter';
import { Result } from '@empathy/search-types';
import { deepMerge } from '@empathybroker/deep-merge';
import { injectable } from 'inversify';

@injectable()
export class CdlIdentifierResultMapper implements Mapper<Result> {
  map(rawResult: any, result: Result): Result {
    try {
      return deepMerge(result, {
        identifier: {
          value: rawResult.isbn,
          html: rawResult.isbn
        }
      });
    } catch (e) {
      console.error(e);
    }
  }
}
